import { Link } from "react-router-dom";
import ellowLogo from "../../assets/images/ellow-logo.svg";
import { Icon } from "@iconify/react";
import Styles from "./styles.module.scss";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
// import { getDetails } from "./services";
import classnames from "classnames";
// import JotformEmbed from 'react-jotform-embed';
import ProfilePicture from '../../modals/profilePicture';
import ConfirmationModal from "../../modals/confirmation/confirmationModal";
import mixpanel from "mixpanel-browser";
import Button from "../../components/button";
import HealthInsuranceModal from "../../modals/healthInsurance";
// import { Auth } from "aws-amplify";




interface Props {
  menu?: { icon: string, title: string, url: string, active: boolean }[]
}

const SideMenu: React.FC<Props> = ({
  menu = [],

}) => {
  // let nameflag = localStorage.getItem('firstname')
  // let jobeflag = localStorage.getItem('jobroles')
  // let lastflag = localStorage.getItem('lastname')
  let navigate = useNavigate();

  const activeContract : any = localStorage.getItem('activeContracts') 
  const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  const profileImage = profileMetadata.image ? profileMetadata.image : " "
  const loginId = localStorage.getItem('loginId')
  const [modal, setModal] = useState<boolean>(false)
  const [insuranceModal, setInsuranceModal] = useState<boolean>(false)
  const [img , setImg]=useState()
  const [sideMenu , setSideMenu] = useState<any>(menu)
  const [logoutModal, setLogoutModal] = useState<boolean>(false)
  const [isSignedOut, setIsSignedOut] = useState(false);

  useEffect(() => {

    if(activeContract === ''){ 
      setSideMenu(sideMenu.filter((item : any)  => {
        return item.title !== 'Timesheet'
      }))
    } 

  },[activeContract])

  

  const logout = () => {
     setLogoutModal(true)
   }
   
   async function onLogout() {
    try {
      await Auth.signOut();
      mixpanel.reset()
      setIsSignedOut(true);
    } catch (error) {
      console.log('Error signing out: ', error);
    }
  }

  if (isSignedOut) {
    navigate('/login')
  }
  
  const hideMobileMenu = () => {
    document.body.classList.remove('mobileMenu');
  }

  const healthInsurance = () => {
    setInsuranceModal(true)
  }

  const uploadPicture = () => {
    setModal(true)
  }

  const onClose = () => {
    setInsuranceModal(false)
    setModal(false)
  }

  return (
    <aside className={classnames(Styles.sideMenu, "sideMenu")}>
      {logoutModal && <ConfirmationModal logout={true} onClose={() => setLogoutModal(false)} submit={onLogout} />}
      <div className={Styles.sideMenuWrap}>
        <div className={Styles.header}>
          <img src={ellowLogo} alt="ellow.io" />
          <button onClick={hideMobileMenu}><Icon icon="eva:close-fill" /></button>
        </div>
        <div className={Styles.userInfo} >
          { profileImage && profileImage === " " ? <figure>
            { profileMetadata.firstName[0]} {profileMetadata.lastName[0]}
          </figure> : 
          <figure>
          <img src={profileImage} />
          </figure> 
          } 
          <label  className={Styles.addProfilePic} onClick={uploadPicture}><Icon icon="ant-design:camera-outlined" /></label>
          <figcaption>{profileMetadata.firstName +" "+ profileMetadata.lastName}</figcaption>
          <div className={Styles.role}>{profileMetadata.jobRoles && profileMetadata.jobRoles.length > 0 ? profileMetadata.jobRoles[0].name : null}</div>
        </div>
        <nav>
          {sideMenu.map((item: any, key: any) => <Link to={item.url} className={item.active ? Styles.active : ""} key={key} onClick={hideMobileMenu}>
            <Icon icon={item.icon}  />
            {item.title}
          </Link>)
          }
          {/* <div className={Styles.healthInsurance}>
            <Button variant="primary" size="xxsmall" onClick={healthInsurance} >
              <Icon icon="material-symbols:stethoscope" width="22"/>
              <p>Health Insurance</p>
            </Button>
          </div> */}
        </nav>
      </div>
      <nav>
        <Link to={''} onClick={logout}>
          <Icon icon="ic:twotone-logout" />
          Logout
        </Link>
      </nav>
      {modal && <ProfilePicture onClose={onClose}/>}
      {insuranceModal && <HealthInsuranceModal onClose={onClose}/>}
    </aside>
  );
}

export default SideMenu;
